import React from "react";
import { FaSearch } from "react-icons/fa";

function SearchableList({
  title,
  items,
  searchTerm,
  setSearchTerm,
  selectedItem,
  onSelectItem,
  renderItem,
  placeholder,
  emptyMessage,
  className,
}) {
  return (
    <div className="mb-0 border rounded-lg overflow-hidden bg-white shadow-sm h-full flex flex-col">
      <div className="p-2 bg-gray-50 border-b">
        <span className="font-medium text-base text-gray-700">{title}</span>
      </div>

      {/* Arama kutusu */}
      <div className="p-2 border-b">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FaSearch className="text-indigo-400 text-md" />
          </div>
          <input
            type="text"
            className="block w-full pl-10 pr-3 py-1.5 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-150 text-base"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Liste */}
      <div className={className}>
        {items.length === 0 ? (
          <span className="py-3 text-center text-gray-500 text-base">
            {emptyMessage}
          </span>
        ) : (
          items.map((item) => (
            <div
              key={item._id}
              className={`p-2 hover:bg-gray-50 cursor-pointer ${
                selectedItem?._id === item._id
                  ? "bg-indigo-50 border-l-4 border-indigo-500"
                  : ""
              }`}
              onClick={() => onSelectItem(item)}
            >
              {renderItem(item)}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default SearchableList;
